import SundayGuardian from "../../../../assets/image/media/SundayGuardian.png"
import LogisticsOutlook from "../../../../assets/image/media/LogisticsOutlook.png"
import TheFreePressJournal from "../../../../assets/image/media/TheFreePressJournal.png"

const MediaContent = [
    {
        date: "August 05, 2023",
        title: "Embracing 4PL: Sellers shifting for hassle-free supply chain solutions",
        description: "Understanding, Advantages and The Future of 4PL Logistics - Opinion Piece by Pawan Kumar, Co-founder of Shipease Technologies Pvt Ltd.",
        author: "Pawan Kumar",
        image: SundayGuardian,
        url: "https://sundayguardianlive.com/business/embracing-4pl-sellers-shifting-for-hassle-free-supply-chain-solutions"
    },
    {
        date: "September 12, 2023",
        title: "Decoding customer buying behaviour at regional level in India",
        description: "An article by Pawan Kumar, Co-Founder and CEO, ShipEase. on the changing landscape of customer buying behaviour in India.",
        author: "ITP Editor",
        image: LogisticsOutlook,
        url: "https://www.logisticsoutlook.com/people/decoding-customer-buying-behaviour-at-regional-level-in-india#:~:text=India%20experiences%20diverse%20climatic%20conditions,to%20seasonal%20demands%20is%20crucial."
    },
    {
        date: "August 05, 2023",
        title: "The Growing Role Of 4pl Logistics In supply Chain Management",
        description: "Understanding, Advantages and The Future of 4PL Logistics - Opinion Piece by Pawan Kumar, Co-founder of Shipease Technologies Pvt Ltd.",
        author: "The Sunday Guardian™",
        image: SundayGuardian,
        url: "/Sunday Guardian  (The Business Guardian - Biz Buzz) - 30th July - 5th August, 2023 - Pg. 20.pdf"
    },
    {
        date: "August 20, 2023",
        title: "Enhancing security in supply chains through blockchain",
        description: "Decentralised nature of blockchain ensures enhanced security against cyber threats and fraud.",
        author: "Pawan Kumar",
        image: "https://www.financialexpress.com/wp-content/themes/ie-network-theme/assets/src/img/logo/fe-transformx.svg",
        url: "https://www.financialexpress.com/business/digital-transformation-enhancing-security-in-supply-chains-through-blockchain-3224263/"
    },
    {
        date: "September 8, 2023",
        title: "Optimising Supply Chain Efficiency : How Technology is Revolutionising Logistics",
        description: "In today’s fast-paced and interconnected world, the logistics and supply chain industry play a pivotal role in global commerce.",
        author: "Pawan Kumar",
        image: "https://timestech.in/wp-content/uploads/2018/10/timestech-logo.png",
        url: "https://timestech.in/optimising-supply-chain-efficiency-how-technology-is-revolutionising-logistics/"
    },
    {
        date: "September 29, 2023",
        title: "Reverse Logistics in the Digital Age: Managing Returns with Tech-Driven Solutions in India",
        description: "In today’s fast-paced digital economy, the management of reverse logistics has become a critical aspect of supply chain operations.",
        author: "Pawan Kumar",
        image: "https://onlinemediacafe.com/wp-content/uploads/2021/05/cropped-logo-new.png",
        url: "https://onlinemediacafe.com/business/reverse-logistics-in-the-digital-age-managing-returns-with-tech-driven-solutions-in-india/"
    },
    {
        date: "September 18, 2023",
        title: "From Inception to Innovation: Know About ShipEase Revolutionizing Logistics Through SaaS and Technology",
        description: "The platform leverages a spectrum of technologies, including artificial intelligence (AI), machine learning (ML), and big data analytics.",
        author: "Oliviya Kunjumon",
        image: TheFreePressJournal,
        url: "https://www.freepressjournal.in/business/from-inception-to-innovation-know-about-shipease-revolutionizing-logistics-through-saas-and-technology"
    },
    {
        date: "August 09, 2023",
        title: "[Exclusive Interview] This SaaS-Based Logistics Company Is Leveraging AI & Other Technologies To Ensure Stunning Performance",
        description: "Recently, we interacted with Mr. Pawan Kumar, co-founder & CEO of ShipEase – one of the fastest-growing SaaS-enabled logistics company in India.",
        author: "Mohul Ghosh",
        image: "https://trak.in/stories//wp-content/uploads/2022/10/Trak.in-final-logo.svg",
        url: "https://trak.in/stories/exclusive-interview-this-saas-based-logistics-company-is-leveraging-ai-other-technologies-to-ensure-stunning-performance/"
    },
    {
        date: "August 21, 2023",
        title: "Global innovators celebrate World Entrepreneurs' Day: Igniting ideas, empowering change!",
        description: "The day acknowledges the role they play in shaping the business landscape.",
        author: "Rohin Ramesh",
        image: "https://www.indiantelevision.com/themes/custom/gavias_batiz/logo.png",
        url: "https://www.indiantelevision.com/mam/marketing/mam/global-innovators-celebrate-world-entrepreneurs-day-igniting-ideas-empowering-change-230821"
    },
    {
        date: "August 21, 2023",
        title: "Entrepreneurs, CEOs, Industry Leaders React On World Entrepreneur's Day - 2023",
        description: "August 21st, 2023 is celebrated as World Entrepreneur’s Day to appreciate and acknowledge all risk-takers and dare-devils, who are determined to create their own legacy by launching and running their startups and businesses.",
        author: "Mohul Ghosh",
        image: "https://trak.in/stories//wp-content/uploads/2022/10/Trak.in-final-logo.svg",
        url: "https://trak.in/stories/entrepreneurs-ceos-industry-leaders-react-on-world-entrepreneurs-day-2023-check-top-quotes-views-more/"
    },
    {
        date: "August 21, 2023",
        title: "Global Trailblazers: Celebrating the Spirit of World Entrepreneurs Day",
        description: "World Entrepreneurs Day is a celebration of the visionary individuals who dare to dream, innovate, and create.",
        author: "CXOtoday News Desk",
        image: "https://cxotoday.com/wp-content/uploads/2018/08/cxo-logo.png",
        url: "https://cxotoday.com/cxo-bytes/global-trailblazers-celebrating-the-spirit-of-world-entrepreneurs-day/"
    },
    {
        date: "July 13, 2023",
        title: "Revolutionising the supply chain: Artificial intelligence’s implications in logistics",
        description: "The logistics industry, with its intricate transportation, warehousing, and distribution network, serves as the backbone of global commerce.",
        author: "Pawan Kumar",
        image: "https://www.constructionweekonline.in/cloud/2021/11/23/cwo-logo.png",
        url: "https://www.constructionweekonline.in/uncategorized/revolutionising-the-supply-chain-artificial-intelligences-implications-in-logistics"
    },
    {
        date: "July 10, 2023",
        title: "Revolutionizing the supply chain: Unveiling the implications of AI in the logistics industry",
        description: "The logistics industry, with its intricate network of transportation, warehousing, and distribution, serves as the backbone of global commerce.",
        author: "Pawan Kumar",
        image: "https://cxotoday.com/wp-content/uploads/2018/08/cxo-logo.png",
        url: "https://cxotoday.com/cxo-bytes/revolutionizing-the-supply-chain-unveiling-the-implications-of-ai-in-the-logistics-industry/"
    },
    {
        date: "July 10, 2023",
        title: "AI in Logistics: How AI is Revolutionizing the Supply Chain",
        description: "The logistics industry, with its intricate network of transportation, warehousing, and distribution, serves as the backbone of global commerce.",
        author: "Pawan Kumar",
        image: "https://timestech.in/wp-content/uploads/2018/10/timestech-logo.png",
        url: "https://timestech.in/ai-in-logistics-how-ai-is-revolutionizing-the-supply-chain/"
    },
    {
        date: "July 10, 2023",
        title: "ShipEase: The Journey of Reinventing Logistics through User-Friendly SaaS Technology and Innovative Solutions",
        description: "The logistics industry, with its intricate network of transportation, warehousing, and distribution, serves as the backbone of global commerce.",
        author: "Pawan Kumar",
        image: "https://cxotoday.com/wp-content/uploads/2018/08/cxo-logo.png",
        url: "https://cxotoday.com/interviews/shipease-the-journey-of-reinventing-logistics-through-user-friendly-saas-technology-and-innovative-solutions/"
    }
]

export default MediaContent;